"use client"

import Image from "next/image";
import { FadeInWhenVisible } from "@/components/animations";
import { useIsDesktop } from "@/hooks/useIsDesktop";

export const Information = () => {
   const isDesktop = useIsDesktop();


  return (
    <section className="bg-white py-12 md:py-16">
      <div className="container flex flex-col md:flex-row items-center justify-between gap-8">
        <FadeInWhenVisible direction={isDesktop ? "left" : "down"} duration={0.8} className="w-full md:w-1/2 text-center md:text-left">
          <p className="text-lg text-gray-800 px-4 leading-relaxed text-justify">
            <b>En Matco, ofrecemos una amplia gama de maquinaria de alta calidad para cubrir todas tus necesidades.</b> Contamos con excavadoras, tractores de cadenas, cargadores de ruedas, motoniveladoras, compactadores de suelos, retroexcavadoras, montacargas, entre otros. Para necesidades temporales de equipo, ponemos a tu disposición la más extensa flota de renta existente de México.
          </p>
        </FadeInWhenVisible>
        <FadeInWhenVisible direction={isDesktop ? "right" : "down"} duration={0.8} className="w-full md:w-1/2 relative h-[150px] md:h-[300px] lg:h-[250px]">
          <Image
            src="/images/mundomatco.png"
            alt="territorioMatco"
            fill
            className="object-contain md:object-bottom"
            priority
          />
        </FadeInWhenVisible>
      </div>
    </section>
  );
};
